import React, { Component } from 'react'
import { connect } from 'react-redux';
import moment from 'moment';
import { get_exitinterview } from './../actions/print.action'

class ExitInterview extends Component {

    constructor( props ){
        super( props );

        this.state = {
            data: [],
            date: ''
        }



    }

    componentWillMount(){
        let user_id = this.props.match.params.id;
        this.props.get_exitinterview( user_id );

        this.setState({
            date: moment( Date() ).format( 'MMMM-DD-YYYY' )
        })

    }

    componentWillReceiveProps( nextProps ){

        if( nextProps.print.length !== 0 ){
            if( nextProps.print.STATUS.CODE === '200' && 
                nextProps.print.STATUS.MESSAGE === "Successfully Listed Exit Interview" ) {
                
                this.setState({
                    data : nextProps.print.OUTPUT.DATA[0]
                }); 

                setTimeout(() => {
                    window.print();
                },500)

            }
            
        }
        

    }


    render() {
        return (
            <div className="print_wrapper letter">
                
                <table width="100%">

                    <thead>
                        <tr>
                            <th colSpan="2">
                                <span className="print_logo"></span>
                                <span className="jgroup_logo"></span>
                            </th>
                        </tr>
                    </thead>

                    <tbody>

                        <tr>
                            <td valign="top">

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <h1 className="letter_head">EXIT INTERVIEW FORM</h1>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                
                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" height="30px"></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="50%">Name: &nbsp;<b>{ this.state.data.full_name }</b></td>
                                            <td width="50%">Date: &nbsp;<b>{ this.state.date }</b></td>
                                        </tr>
                                        <tr>
                                            <td width="50%">Designation: &nbsp;<b>{ this.state.data.designation_name }</b></td>
                                            <td width="50%">Department: &nbsp;<b>{ this.state.data.department_name }</b></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" height="30px"></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%">
                                                <h2>Reason for Leaving</h2>  
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%" border="1">
                                    <tbody>
                                        <tr>
                                            <td width="50%">
                                                <table width="100%" >
                                                    <tbody>
                                                        <tr><td align="center" style={{height: '30px', lineHeight: '30px', 
                                                            backgroundColor: '#a0c8f6', fontWeight: 'bold'}}>VOLUNTARY</td></tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                            <td width="50%">
                                                <table width="100%">
                                                    <tbody>
                                                        <tr><td align="center" style={{height: '30px', lineHeight: '30px', 
                                                            backgroundColor: '#a0c8f6', fontWeight: 'bold' }}>INVOLUNTARY</td></tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="50%">
                                                <table width="100%">
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ borderRight: 'solid 1px #000', borderBottom: 'solid 1px #000' }} width="10%" height="30px"></td>
                                                            <td style={{ paddingLeft: '10px',borderBottom: 'solid 1px #000' }} width="90%" height="30px">Personal Reasons</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ borderRight: 'solid 1px #000',borderBottom: 'solid 1px #000' }} width="10%" height="30px"></td>
                                                            <td style={{ paddingLeft: '10px',borderBottom: 'solid 1px #000' }} width="90%" height="30px">Better Opportunity</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ borderRight: 'solid 1px #000',borderBottom: 'solid 1px #000' }} width="10%" height="30px"></td>
                                                            <td style={{ paddingLeft: '10px',borderBottom: 'solid 1px #000' }} width="90%" height="30px">Retirement</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ borderRight: 'solid 1px #000',borderBottom: 'solid 1px #000' }} width="10%" height="30px"></td>
                                                            <td style={{ paddingLeft: '10px',borderBottom: 'solid 1px #000' }} width="90%" height="30px">Relocating</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ borderRight: 'solid 1px #000' }} width="10%" height="30px"></td>
                                                            <td style={{ paddingLeft: '10px' }} width="90%" height="30px">Other:</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                            <td width="50%">
                                                <table width="100%">
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ borderRight: 'solid 1px #000', borderBottom: 'solid 1px #000' }} width="10%" height="30px"></td>
                                                            <td style={{ paddingLeft: '10px',borderBottom: 'solid 1px #000' }} width="90%" height="30px">Lay Off</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ borderRight: 'solid 1px #000',borderBottom: 'solid 1px #000' }} width="10%" height="30px"></td>
                                                            <td style={{ paddingLeft: '10px',borderBottom: 'solid 1px #000' }} width="90%" height="30px">Position Eliminated</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ borderRight: 'solid 1px #000',borderBottom: 'solid 1px #000' }} width="10%" height="30px"></td>
                                                            <td style={{ paddingLeft: '10px',borderBottom: 'solid 1px #000' }} width="90%" height="30px">Reorganization</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ borderRight: 'solid 1px #000',borderBottom: 'solid 1px #000' }} width="10%" height="30px"></td>
                                                            <td style={{ paddingLeft: '10px',borderBottom: 'solid 1px #000' }} width="90%" height="30px">Violation of Company Policy</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ borderRight: 'solid 1px #000' }} width="10%" height="30px"></td>
                                                            <td style={{ paddingLeft: '10px' }} width="90%" height="30px">Other:</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" height="30px"></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%">
                                                <h2>Questionnaire</h2>  
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%"><em>Question only applies if the answer for the above is better opportunity.</em>  </td>
                                        </tr>
                                        <tr>
                                            <td width="100%">What prompted you to seek alternative employment?  [Not applicable for those end of contract or termination]</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" height="30px"></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="50%">____Type of work</td>
                                            <td width="50%">____Quality of supervision</td>
                                        </tr>
                                        <tr>
                                            <td width="50%">____Compensation</td>
                                            <td width="50%">____Work conditions</td>
                                        </tr>
                                        <tr>
                                            <td width="50%">____Harassment</td>
                                            <td width="50%">____Discrimination</td>
                                        </tr>
                                        <tr>
                                            <td width="50%">____Lack of recognition</td>
                                            <td width="50%">____Family circumstances</td>
                                        </tr>
                                        <tr>
                                            <td width="50%">____Self-employment</td>
                                            <td width="50%">____Health reasons</td>
                                        </tr>
                                        <tr>
                                            <td width="50%">____Too much pressure to meet targets</td>
                                            <td width="50%">____Uncertainty over job continuation</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%">____Inability to sustain advancement in disciplinary skills</td>
                                        </tr>
                                        <tr>
                                            <td width="100%">____Lack of challenges and opportunities to function in a multi-disciplinary environment</td>
                                        </tr>
                                        <tr>
                                            <td width="100%">_______________________________________Career opportunity (Please describe) </td>
                                        </tr>
                                        <tr>
                                            <td width="100%">_______________________________________Other (Please specify)</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '50px' }}></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ padding: '20px 0' }}>What did you find most satisfying about your job and or the organization?</td>
                                        </tr>
                                        <tr>
                                            <td width="100%"><hr style={{ borderColor: '#000' }} /></td>
                                        </tr>
                                        <tr>
                                            <td width="100%"><hr style={{ borderColor: '#000' }} /></td>
                                        </tr>
                                        <tr>
                                            <td width="100%"><hr style={{ borderColor: '#000' }} /></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '50px' }}></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ padding: '20px 0' }}>What did you find the most frustrating about your job and or the organization?</td>
                                        </tr>
                                        <tr>
                                            <td width="100%"><hr style={{ borderColor: '#000' }} /></td>
                                        </tr>
                                        <tr>
                                            <td width="100%"><hr style={{ borderColor: '#000' }} /></td>
                                        </tr>
                                        <tr>
                                            <td width="100%"><hr style={{ borderColor: '#000' }} /></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div style={{ pageBreakBefore: 'always' }}>&nbsp;</div>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '120px' }}></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ padding: '20px 0' }}>Were there any company procedures or policies that made your job more difficult?</td>
                                        </tr>
                                        <tr>
                                            <td width="100%"><hr style={{ borderColor: '#000' }} /></td>
                                        </tr>
                                        <tr>
                                            <td width="100%"><hr style={{ borderColor: '#000' }} /></td>
                                        </tr>
                                        <tr>
                                            <td width="100%"><hr style={{ borderColor: '#000' }} /></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '50px' }}></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ padding: '20px 0' }}>Would you recommend this company to a colleague or friend as a good place to work?</td>
                                        </tr>
                                        <tr>
                                            <td width="100%"><hr style={{ borderColor: '#000' }} /></td>
                                        </tr>
                                        <tr>
                                            <td width="100%"><hr style={{ borderColor: '#000' }} /></td>
                                        </tr>
                                        <tr>
                                            <td width="100%"><hr style={{ borderColor: '#000' }} /></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '50px' }}></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ padding: '20px 0' }}>Is there anything that the company or your manager could have done to prevent you from leaving?</td>
                                        </tr>
                                        <tr>
                                            <td width="100%"><hr style={{ borderColor: '#000' }} /></td>
                                        </tr>
                                        <tr>
                                            <td width="100%"><hr style={{ borderColor: '#000' }} /></td>
                                        </tr>
                                        <tr>
                                            <td width="100%"><hr style={{ borderColor: '#000' }} /></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '50px' }}></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ padding: '20px 0' }}>Would you consider returning to work for this company in the future? (If terminated, not applicable)</td>
                                        </tr>
                                        <tr>
                                            <td width="100%"><hr style={{ borderColor: '#000' }} /></td>
                                        </tr>
                                        <tr>
                                            <td width="100%"><hr style={{ borderColor: '#000' }} /></td>
                                        </tr>
                                        <tr>
                                            <td width="100%"><hr style={{ borderColor: '#000' }} /></td>
                                        </tr>
                                    </tbody>
                                </table>
                                
                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '50px' }}></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ padding: '20px 0' }}>As a learning organization, we very much appreciate you highlighting your concerns in such an open manner so that we can explore avenues for improvement. Having been with the organization for a certain amount of time, are there any areas that you think we should make efforts to improve?</td>
                                        </tr>
                                        <tr>
                                            <td width="100%"><hr style={{ borderColor: '#000' }} /></td>
                                        </tr>
                                        <tr>
                                            <td width="100%"><hr style={{ borderColor: '#000' }} /></td>
                                        </tr>
                                        <tr>
                                            <td width="100%"><hr style={{ borderColor: '#000' }} /></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div style={{ pageBreakBefore: 'always' }}>&nbsp;</div>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '120px' }}></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%">
                                                <h2>Comments</h2>  
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%">
                                                <span style={{position: 'relative', background: '#fff', bottom: '-22px' }}>Employee Comments:</span>
                                                <hr style={{ borderColor: '#000' }} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="100%"><hr style={{ borderColor: '#000' }} /></td>
                                        </tr>
                                        <tr>
                                            <td width="100%"><hr style={{ borderColor: '#000' }} /></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '30px' }}></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%">
                                                <span style={{position: 'relative', background: '#fff', bottom: '-22px' }}>Interviewer Comments: </span>
                                                <hr style={{ borderColor: '#000' }} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="100%"><hr style={{ borderColor: '#000' }} /></td>
                                        </tr>
                                        <tr>
                                            <td width="100%"><hr style={{ borderColor: '#000' }} /></td>
                                        </tr>
                                    </tbody>
                                </table>


                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '100px' }}></td>
                                        </tr>
                                    </tbody>
                                </table>


                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%">Signature:</td>
                                        </tr>
                                        <tr>
                                            <td width="100%">
                                                <span style={{position: 'relative', background: '#fff', bottom: '-22px' }}>
                                                    Employee Name:
                                                </span>
                                                <hr style={{ borderColor: '#000' }} style={{width: '35%' }} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="100%">
                                                <span style={{position: 'relative', background: '#fff', bottom: '-22px' }}>
                                                    Date:
                                                </span>
                                                <hr style={{ borderColor: '#000' }} style={{width: '35%' }} />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '30px' }}></td>
                                        </tr>
                                    </tbody>
                                </table>


                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%">Signature:</td>
                                        </tr>
                                        <tr>
                                            <td width="100%">
                                                <span style={{position: 'relative', background: '#fff', bottom: '-22px' }}>
                                                    Employee Name:
                                                </span>
                                                <hr style={{ borderColor: '#000' }} style={{width: '35%' }} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="100%">
                                                <span style={{position: 'relative', background: '#fff', bottom: '-22px' }}>
                                                    Date:
                                                </span>
                                                <hr style={{ borderColor: '#000' }} style={{width: '35%' }} />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </td>
                        </tr>

                    </tbody>

                </table>


            </div>
        )
    }
}

function mapStatetoProps( state ){
    return {
        print: state.print
    }
}

export default connect( mapStatetoProps, { get_exitinterview } )( ExitInterview );



// WEBPACK FOOTER //
// ./src/pages/prints/exitinterview/index.js